/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_Import_Reason_No_VeknInputs */



/**
* | output |
* | --- |
* | "member has no VEKN ID — sponsor them first" |
*
* @param {Csv_Import_Reason_No_VeknInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const csv_import_reason_no_vekn = /** @type {((inputs?: Csv_Import_Reason_No_VeknInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_Import_Reason_No_VeknInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("le membre n'a pas d'identifiant VEKN — à parrainer d'abord")
	if (locale === "es") return /** @type {LocalizedString} */ ("el miembro no tiene ID de VEKN — patrocinarlo primero")
	if (locale === "pt") return /** @type {LocalizedString} */ ("o membro não tem ID VEKN — patrociná-lo primeiro")
	if (locale === "it") return /** @type {LocalizedString} */ ("il membro non ha un ID VEKN — sponsorizzarlo prima")
	return /** @type {LocalizedString} */ ("member has no VEKN ID — sponsor them first")
});